import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export default function DropDownItem(
  { onClick, children, disabled = false },
  context
) {
  const click = e => {
    e.stopPropagation();
    onClick();
    if (context && context.close) context.close();
  };

  return (
    <li
      onClick={disabled ? () => {} : click}
      className={classNames({ disabled })}
    >
      <a
        className="btn-link"
        role="button"
        style={{ cursor: disabled ? "not-allowed" : "pointer" }}
      >
        {children}
      </a>
    </li>
  );
}

DropDownItem.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ])
};

DropDownItem.contextTypes = { close: PropTypes.func };



// WEBPACK FOOTER //
// ./app/modules/shared/components/DropDown/DropDownItem.jsx